import { useState } from "react";
import { CatagoryList } from "../CatagoryList";
import heroImage from "../../assets/images/hero_right.png";

function HeroPage() {
  const [hoveredMenu, setHoveredMenu] = useState<string | null>(null);

  const handleMouseEnter = (menu: string) => setHoveredMenu(menu);
  const handleMouseLeave = () => setHoveredMenu(null);

  return (
    <div className="flex flex-col md:flex-row items-center w-full h-screen px-8 py-6 bg-gray-50">
      {/* Left Section */}
      <div className="flex flex-col w-full md:w-1/2 space-y-6 md:space-y-8 justify-center">
        {/* Navigation Menu */}
        <div className="flex space-x-8 text-lg font-medium text-gray-700">
          {["Restaurants", "Home Services", "Auto Services", "More"].map(
            (menu) => (
              <div
                key={menu}
                onMouseEnter={() => handleMouseEnter(menu)}
                onMouseLeave={handleMouseLeave}
                className="relative cursor-pointer group"
              >
                <p className="hover:text-indigo-600 transition-colors duration-300">
                  {menu}
                </p>
                {hoveredMenu === menu && (
                  <div className="absolute left-0 mt-0 p-4 w-96 bg-white shadow-xl rounded-lg space-y-3 z-10 animate-fade-in flex flex-wrap">
                    {CatagoryList[menu]?.length ? (
                      CatagoryList[menu].map((item, index) => (
                        <div
                          key={item.name}
                          className="flex items-center space-x-3 hover:text-indigo-600 transition duration-300 w-1/2"
                        >
                          <span className="text-indigo-500 text-xl">
                            {item.icon}
                          </span>
                          <p className="text-gray-800">{item.name}</p>
                        </div>
                      ))
                    ) : (
                      <p className="text-gray-500">No items available</p>
                    )}
                  </div>
                )}
              </div>
            )
          )}
        </div>

        {/* Hero Heading */}
        <div>
          <h1 className="text-gray-900 font-extrabold text-4xl md:text-6xl leading-tight">
            Are You Looking For A <br />
            <span className="text-primary">Business?</span>
          </h1>
        </div>

        {/* Hero Description */}
        <div>
          <p className="text-gray-600 text-lg md:text-xl leading-relaxed">
            Discover top-rated services near you. From dining experiences to
            home care professionals, find what you need quickly and efficiently.
          </p>
        </div>
      </div>

      {/* Right Section */}
      <div className="w-full md:w-1/2 flex justify-center items-center mt-5">
        <img
          src={heroImage}
          alt="Hero Section"
          className="w-full max-w-[500px] md:max-w-[570px] rounded-2xl shadow-2xl"
        />
      </div>
    </div>
  );
}

export default HeroPage;
